import React, { useContext } from 'react'
import { ArrowRight } from 'lucide-react'
import Header from './header/Header'
import { HeaderType } from '../vars'
import { UserDetailsContext } from '../context/userDetails'
import SpecificButton from './specificButton/SpecificButton'

function OnboardingSummary({ onNext }) {
    const { name, email } = useContext(UserDetailsContext)
    return (
        <div className="h-full  pb-0 flex-col pt-4 relative px-4 w-full flex  items-center text-center bg-primary rounded-t-[20px]">
            <div className=" w-full max-w-[330px]">
          
                <Header headerTop="logoOnly" whatTypeHeader={HeaderType.Deafult} heading="Consumer Details" subheading="Your measurement will be saved to your MY knitever profile" />
            </div>

            <div className=' max-w-md flex-1  mx-auto my-8  px-4 text-left'>
                <p><strong className='w-[60px] inline-block'>Name:</strong> {name}</p>
                <p><strong  className='w-[60px] inline-block'>Email:</strong> {email}</p>
           
            </div>
            <div className='w-full mt-4 w-full justify-end  flex mb-[1.25rem]'>
 <SpecificButton btnSecondary postfixIcon={<ArrowRight />} buttonText="Next" buttonFunc={onNext} />
            </div>
           
        </div>

    )
}

export default OnboardingSummary